import { render, staticRenderFns } from "./EditLiveInformationsForm.vue?vue&type=template&id=73d3523a"
import script from "./EditLiveInformationsForm.vue?vue&type=script&lang=js"
export * from "./EditLiveInformationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports